import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/PartSearchResultsAllocations'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class PartSearchResultsAllocationsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "PartSearchResultsAllocationsStore",
			variables: false,
		})
	}
}

export async function load_PartSearchResultsAllocations(params) {
  await initClient()

	const store = new PartSearchResultsAllocationsStore()

	await store.fetch(params)

	return {
		PartSearchResultsAllocations: store,
	}
}
